import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  background: ${(props) => props.theme.colors.white};
  border: 0.5px solid ${(props) => props.theme.colors.silverGrayTwo};
  border-radius: 16px;
  padding: 24px;
`;

export const CardContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

export const CardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const MockAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 32px;
  border: 1px solid ${(props) => props.theme.colors.primaryLighter};
  background: ${(props) => props.theme.colors.activeBlue};
  color: ${(props) => props.theme.colors.white};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ContentBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  flex: 1;
  min-width: 0;
`;

export const ContactName = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.black};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 18px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.25px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const InfoText = styled.span`
  color: ${(props) => props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
`;

export const InfoGroup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const Separator = styled.span`
  color: #99a1af;
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const CardRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

